import type { TFunction } from "i18next";
import { memo } from "react";

import { MarketListRows } from "./MarketListRows";
import { HeaderMarketCell, ScrollContainer, StickyHeader, TitleText } from "./styles";

interface MarketListTableProps {
  t: TFunction<"translation", undefined>;
  search: string;
  showFavorites: boolean;
  onSelect: (marketAddr: string) => void;
  onToggleFavorite: (address: string) => void;
}

// Memo - header and ScrollContainer don't re-render when ticker data updates, only MarketListRows does
export const MarketListTable = memo(
  ({ t, search, showFavorites, onSelect, onToggleFavorite }: MarketListTableProps) => (
    <ScrollContainer className="better-scroll-invisible" data-testid="market-select:list">
      <StickyHeader>
        <HeaderMarketCell>{t("common.market")}</HeaderMarketCell>
        <TitleText>{t("market.lastPrice")}</TitleText>
        <TitleText>{t("market.change24h")}</TitleText>
        <TitleText>{t("market.fundingRate")}</TitleText>
        <TitleText>{t("market.volume24h")}</TitleText>
        <TitleText align="right">{t("market.openInterest")}</TitleText>
      </StickyHeader>
      <MarketListRows
        search={search}
        showFavorites={showFavorites}
        onSelect={onSelect}
        onToggleFavorite={onToggleFavorite}
      />
    </ScrollContainer>
  ),
);

MarketListTable.displayName = "MarketListTable";
